import showPopup from '../modals';
import { showLoader, hideLoader } from '../utils/utils';


async function PreparePayload(form) {
    const productId = form.getAttribute('data-product-id');
    const positionId = form.getAttribute('data-position-id');
    const token = form.getAttribute('data-token');

    const request = {
        Rating: Number(form.elements['product-comment-rating'].value),
        RatingUser: form.elements['product-comment-author'].value,
        RatingBody: form.elements['product-comment-opinion'].value,
        PositionId: positionId,
        ProductId: productId,
        Token: token
    };

    const fileInput = form.querySelector('input[type="file"]');
    const file = fileInput?.files[0];

    if (file) {
        const base64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });

        request.Attachment = {
            FileName: file.name,
            ContentType: file.type,
            Base64: base64
        };
    }

    return request;
}


const commentFormSubmit = form => {
    
    showLoader();
    PreparePayload(form).then(payload => {
             
        fetch('/api/frontend/RateProduct', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(response => response.json())
            .then(data => {
                form.closest('.single-comment-row').classList.add('product-commented');
                hideLoader();
                showPopup({ body: data.message });
            })
            .catch(error => {
                hideLoader();
            });

    });

};

export default function () {
    const addCommentForms = document.querySelectorAll('.add-comment-form');

    addCommentForms.forEach(form => {
        let stars = form.querySelectorAll('.star-choosing li');
        stars.forEach((li, outerIndex) => {

            li.addEventListener('click', function () {
                stars.forEach((li, innerIndex) => {

                    li.classList.remove('rated');
                    if (innerIndex <= outerIndex) li.classList.add('rated');
                });

                form.querySelector('input[name=product-comment-rating]').value = outerIndex + 1;
            });
        });
    });
}

export { commentFormSubmit };